import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core';
import { AddAlert } from '@material-ui/icons';
import GridItem from '../../components/Grid/GridItem';
import CardBody from '../../components/Card/CardBody';
import GridContainer from '../../components/Grid/GridContainer';
import Card from '../../components/Card/Card';
import Snackbar from '../../components/Snackbar/Snackbar';
import GeneralInputFormBlock from './FormParts/GeneralInputFormBlock';
import ContentFormBlock from './FormParts/ContentFormBlock';
import Header from '../../components/Header';
import Button from '../../components/CustomButtons/Button';
import Loading from '../../components/Loading';
import { updateFeature } from '../../dataService/updateFeature';
import { getFeatureDetails } from '../../dataService/getFeatureDetails';
import { yupSchemaObject, initialValues } from './formSchema';

const AddNewFeature = ({
  match: {
    params: { featureCode },
  },
}) => {
  const classes = useStyles();
  const [formValues, setFormValues] = useState(initialValues);
  const validationSchema = Yup.object(yupSchemaObject);
  const [isLoaded, setIsLoaded] = useState(false);
  const [submitDisable, setSubmitDisable] = useState(false);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: '',
    color: 'success',
  });

  const snackBarClose = () => {
    setSnackbarConfig({ ...snackbarConfig, open: false });
  };

  const setSchemaAndInitialValueForEditForm = async featureCode => {
    const { data: formValues } = await getFeatureDetails(featureCode, true);
    setFormValues(formValues);
    setIsLoaded(true);
  };

  useEffect(() => {
    setSchemaAndInitialValueForEditForm(featureCode);
  }, []);

  const onSubmit = async values => {
    setSubmitDisable(true);

    const { status, message } = await updateFeature(values);

    if (status === 'success') {
      setSubmitDisable(false);
      setSnackbarConfig({
        open: true,
        message,
        icon: AddAlert,
        color: 'success',
      });
      setSchemaAndInitialValueForEditForm(featureCode);
    } else {
      setSubmitDisable(false);
      setSnackbarConfig({
        open: true,
        message,
        icon: AddAlert,
        color: 'danger',
      });
    }
  };

  if (!isLoaded) {
    return (
      <>
        {/* <Header title="Edit Feature" /> */}
        <Card style={{ backgroundColor: '#800054' }}>
          <CardBody>
            <h3 style={{ color: '#ffffff' }}>
              <b>Edit Feature: {featureCode}</b>
            </h3>
          </CardBody>
        </Card>
        <Loading
          className={classes.pageTopSpacing}
          boxHeight="calc(100vh - 122px)"
        />
      </>
    );
  }

  return (
    <>
    
      <Card style={{ backgroundColor: '#800054' }}>
        <CardBody>
          <h3 style={{ color: '#ffffff' }}>
            <b>Edit Feature: {featureCode}</b>
          </h3>
        </CardBody>
      </Card>
      <Formik
        enableReinitialize
        initialValues={formValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {formik => (
          <form
            className={classes.pageTopSpacing}
            onSubmit={formik.handleSubmit}
          >
            <GridContainer>
              <GridItem xs={12}>
                <GeneralInputFormBlock formik={formik} isEdit />

                <div className={classes.blockSpacing} />
                <ContentFormBlock formik={formik} />
             
                <GridContainer>
                  <GridItem>
                    <Button
                      disabled={
                        submitDisable ||
                        (formik.isValid && !formik.dirty) ||
                        !formik.isValid
                      }
                      color="success"
                      type="submit"
                    >
                      Update feature
                    </Button>
                  </GridItem>
                </GridContainer>
               
              </GridItem>
            </GridContainer>
          </form>
        )}
      </Formik>
      <Snackbar
        {...snackbarConfig}
        icon={AddAlert}
        close
        closeNotification={snackBarClose}
        place="bl"
      />
    </>
  );
};

const useStyles = makeStyles({
  pageTopSpacing: {
    marginTop: '30px',
  },
  blockSpacing: {
    marginTop: '60px',
  },
});

export default AddNewFeature;
